@for (color of colors; track $index) {
<div
  class="color"
  [ngStyle]="{'background-color':color.color}"
  [ngClass]="{'disabled':disabled}"
  (click)="onColorChanged(color.name)"
  [matTooltip]="color.name"
  matTooltipPosition="above"
>
  <mat-icon
    fontSet="material-symbols-outlined"
    inline
    [ngClass]="{active:color.name===value}"
    >check</mat-icon
  >
</div>
}
